import React from 'react';
import { IIconProps } from './utils';

export const CaretOpened = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.442 11.6919L21.4331 17.6831C21.8268 18.0768 21.548 18.75 20.9912 18.75L9.00895 18.75C8.45213 18.75 8.17328 18.0768 8.567 17.6831L14.5581 11.6919C14.8022 11.4479 15.1979 11.4479 15.442 11.6919Z"
      fill={fill}
    />
  </svg>
);
